import { Component, OnInit } from '@angular/core';
import { IntlService } from '@sinequa/core/intl';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  public footerTag = this.intlService.formatMessage("msg#footer.tag");
  public symbol = this.intlService.formatMessage("msg#footer.symbol");

  constructor(private intlService: IntlService) { }

  ngOnInit(): void {
  }

}
